/*
 * VerificationCancellationProof Messages
 *
 * This contains all the text for the VerificationCancellationProof component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.VerificationsPage.VerificationCancellationProof';

export default defineMessages({
  uploadedOnLabel: {
    id: `${scope}.uploadedOnLabel`,
    defaultMessage: 'Uploaded on {date}',
  },
  createdOnLabel: {
    id: `${scope}.createdOnLabel`,
    defaultMessage: 'Created on {date}',
  },
  declineButton: {
    id: `${scope}.declineButton`,
    defaultMessage: 'Decline',
  },
  approveButton: {
    id: `${scope}.approveButton`,
    defaultMessage: 'Approve',
  },
  retryButton: {
    id: `${scope}.retryButton`,
    defaultMessage: 'Retry',
  },
  approveConfirmMessage: {
    id: `${scope}.approveConfirmMessage`,
    defaultMessage: 'Are you sure you want to approve this Proof?',
  },
  rejectConfirmMessage: {
    id: `${scope}.rejectConfirmMessage`,
    defaultMessage: 'Are you sure you want to reject this Proof?',
  },
  cancelIdLabel: {
    id: `${scope}.cancelIdLabel`,
    defaultMessage: 'Cancel ID: {id}',
  },
  jobIdLabel: {
    id: `${scope}.jobIdLabel`,
    defaultMessage: 'Job ID: {id}',
  },
  cancelledShiftLabel: {
    id: `${scope}.cancelledShiftLabel`,
    defaultMessage: 'Cancelled Shift',
  },
  cancelReasonLabel: {
    id: `${scope}.cancelReasonLabel`,
    defaultMessage: 'Cancel Reason',
  },
  userExplanationLabel: {
    id: `${scope}.userExplanationLabel`,
    defaultMessage: 'User Explanation',
  },
  rejectionReasonLabel: {
    id: `${scope}.rejectionReasonLabel`,
    defaultMessage: 'Rejection Reason',
  },
  adminCommentLabel: {
    id: `${scope}.adminCommentLabel`,
    defaultMessage: 'Admin Comment',
  },
  healthInsuranceProviderLabel: {
    id: `${scope}.healthInsuranceProviderLabel`,
    defaultMessage: 'Health Insurance',
  },
  healthInsuranceNumberLabel: {
    id: `${scope}.healthInsuranceNumberLabel`,
    defaultMessage: 'Insurance Number',
  },
  firstSicknoteDateLabel: {
    id: `${scope}.firstSicknoteDateLabel`,
    defaultMessage: 'First Sicknote Day',
  },
  eauLinkMessage: {
    id: `${scope}.eauLinkMessage`,
    defaultMessage: 'Go to eAU Portal',
  },
  numberCopiedSuccess: {
    id: `${scope}.numberCopiedSuccess`,
    defaultMessage: 'Number copied',
  },
  eAUTitle: {
    id: `${scope}.eAUTitle`,
    defaultMessage: 'eAU Information',
  },
});
